(() => {
  if (customElements.get('yds-dispatch-timeline')) return;
  class YdsDispatchTimeline extends HTMLElement {
    static played = false;
    static calendar = {
      timeZone: 'Pacific/Auckland',
      validFrom: '2026-01-01',
      validThrough: '2027-12-31',
      source: 'https://www.govt.nz/browse/work-and-tax/public-holidays-and-work/dates-for-public-holidays-and-anniversary-days/',
      holidays: [
        '2026-01-01', '2026-01-02', '2026-02-06', '2026-04-03', '2026-04-06', '2026-04-27',
        '2026-06-01', '2026-07-10', '2026-10-23', '2026-10-26', '2026-12-25', '2026-12-28',
        '2027-01-01', '2027-01-04', '2027-02-08', '2027-03-26', '2027-03-29', '2027-04-26',
        '2027-06-07', '2027-06-25', '2027-10-22', '2027-10-25', '2027-12-27', '2027-12-28'
      ],
      additionalClosures: []
    };
    static estimate(now = new Date()) {
      const config = this.calendar;
      const parts = new Intl.DateTimeFormat('en-NZ', { timeZone: config.timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
      const part = type => parts.find(p => p.type === type).value;
      const today = `${part('year')}-${part('month')}-${part('day')}`;
      if (today < config.validFrom || today > config.validThrough) return null;
      const closed = new Set([...config.holidays, ...config.additionalClosures]);
      const date = new Date(`${today}T12:00:00Z`);
      const days = [];
      while (days.length < 4) {
        date.setUTCDate(date.getUTCDate() + 1);
        const key = date.toISOString().slice(0, 10);
        if (key > config.validThrough) return null;
        if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !closed.has(key)) days.push(key);
      }
      return { today, production: days.slice(0, 2), dispatch: days.slice(2, 4) };
    }
    static label(day) {
      return new Intl.DateTimeFormat('en-NZ', { timeZone: 'UTC', day: 'numeric', month: 'short' }).format(new Date(`${day}T12:00:00Z`));
    }
    connectedCallback() {
      this.refresh = () => {
        try {
          const dates = YdsDispatchTimeline.estimate();
          this.hidden = !dates;
          if (!dates) return;
          this.querySelector('[data-dispatch-order]').textContent = YdsDispatchTimeline.label(dates.today);
          this.querySelector('[data-dispatch-production]').textContent = dates.production.map(day => YdsDispatchTimeline.label(day)).join(' – ');
          this.querySelector('[data-dispatch-date]').textContent = dates.dispatch.map(day => YdsDispatchTimeline.label(day)).join(' – ');
        } catch (_) { this.hidden = true; }
      };
      this.refresh();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.finishMotion = () => {
        this.classList.remove('yds-dispatch--waiting', 'yds-dispatch--playing');
        this.observer?.disconnect();
        clearTimeout(this.motionTimer);
      };
      this.motionChange = () => {
        if (this.motion.matches) { YdsDispatchTimeline.played = true; this.finishMotion(); }
      };
      this.motion.addEventListener('change', this.motionChange);
      if (!YdsDispatchTimeline.played && !this.motion.matches && 'IntersectionObserver' in window) {
        this.classList.add('yds-dispatch--waiting');
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          YdsDispatchTimeline.played = true;
          this.observer.disconnect();
          this.classList.remove('yds-dispatch--waiting');
          this.classList.add('yds-dispatch--playing');
          this.motionTimer = setTimeout(this.finishMotion, 1050);
        }, { threshold: 0 });
        this.observer.observe(this);
      } else { YdsDispatchTimeline.played = true; }
      this.timer = setInterval(this.refresh, 60000);
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      this.finishMotion?.();
      this.motion?.removeEventListener('change', this.motionChange);
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  }
  customElements.define('yds-dispatch-timeline', YdsDispatchTimeline);
})();
